import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import type from './types';
import { toastr } from 'react-redux-toastr';

const URL_ACCOUNTING_PROCESSES = `${BASE_API}/accounting-processes`;
const URL_APPOINTMENTS = `${BASE_API}/accounting-appointments`;
const URL_NEWS = `${BASE_API}/accounting/news`;

export const getProcessesList = () => {
  return (dispatch) => {
    dispatch({ type: 'ACCOUNTING_PROCESSES_LOAD', payload: true });
    axios
      .get(`${URL_ACCOUNTING_PROCESSES}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'ACCOUNTING_PROCESSES_FETCHED',
            payload: response.data,
          },
        ]);
      })
      .catch((e) => {
        dispatch({ type: 'ACCOUNTING_PROCESSES_LOAD', payload: false });
      });
  };
};

export const getAppointmentsList = () => {
  return (dispatch) => {
    dispatch({ type: 'APPOINTMENTS_LOAD', payload: true });
    axios
      .get(`${URL_APPOINTMENTS}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: 'APPOINTMENTS_FETCHED',
            payload: response.data,
          },
        ]);
      })
      .catch((e) => {
        dispatch({ type: 'APPOINTMENTS_LOAD', payload: false });
      });
  };
};

export const setLoading = (value) => {
  return (dispatch) => {
    dispatch([{ type: type.LIST_LOAD, payload: value }]);
  };
};

export const sendAppointmentRequest = (values, cleanup) => {
  return (dispatch) => {
    dispatch({ type: 'APPOINTMENTS_LOAD', payload: true });
    axios
      .post(`${URL_APPOINTMENTS}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([{ type: 'APPOINTMENTS_LOAD', payload: false }]);
        cleanup();
        toastr.success('Sucesso', 'Solicitação enviada com sucesso.');
      })
      .catch((e) => {
        dispatch([{ type: 'APPOINTMENTS_LOAD', payload: false }]);
        try {
          toastr.error('Erro', e.response.data.messages[0]);
        } catch {
          toastr.error('Erro');
        }
      });
  };
};

export const getNewsList = (page, tagId) => {
  return (dispatch) => {
    dispatch({
      type: type.NEWS_LIST_LOAD,
      payload: true,
    });
    axios
      .get(`${URL_NEWS}?page=${page}&tagId=${tagId}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch({
          type: type.NEWS_LIST_FETCHED,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch([
          {
            type: type.NEWS_LIST_LOAD,
            payload: false,
          },
        ]);
      });
  };
};

export const setNewsList = (value) => {
  return (dispatch) => {
    dispatch([{ type: type.NEWS_LIST_SET, payload: value }]);
  };
};
